export const Contents = (props) => {
    return (
        <div id="contents">
            <div className="container">
                <div className="row">
                    <div className="">
                        <div className="section-title">
                            <h2>Currícula</h2>
                            <p>
                                Contamos con un programa curricular completo diseñado
                                pedagógicamente.
                            </p>
                        </div>
                        <div id="exTab1">
                            <ul className="nav nav-pills"
                                style={{justifyContent: "center", gap: "1rem", display: "flex"}}>
                                <li className="active">
                                    <a href="#1a" data-toggle="tab">
                                        Nivel Inicial
                                    </a>
                                </li>
                                <li>
                                    <a href="#2a" data-toggle="tab">
                                        Primario: 1º a 7º
                                    </a>
                                </li>
                                <li>
                                    <a href="#3a" data-toggle="tab">
                                        Secundario: 8º a 12º
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content clearfix" style={{marginTop: "1rem"}}>
                                <div className="tab-pane active" id="1a">
                                    <div className="list-style">
                                        <div className="tab-body">
                                            Desde este espacio, proponemos un recorrido compartido,
                                            donde el hogar se transforma en un ambiente rico en
                                            experiencias, juegos, aprendizajes y descubrimientos. La enseñanza en el
                                            Nivel Inicial no se configura desde las áreas
                                            disciplinares, sino que se estructura desde el carácter
                                            globalizador de la experiencia infantil, enriquecida
                                            desde las miradas que pueden aportar las diferentes
                                            disciplinas. <br/><br/>
                                            <span style={{paddingLeft: "2em"}}/>
                                            Este proceso no busca replicar una escuela, sino aprovechar la intimidad y
                                            cercanía del entorno familiar como terreno fértil para
                                            aprender con libertad y afecto.

                                            <div className="row g-4 mb-4" style={{marginTop: "2rem"}}>
                                                <div className="col-md-6">
                                                    <div
                                                        className="card"
                                                        style={{
                                                            backgroundColor: "#FFF5F0", borderColor: "#FF5500"
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: "#FFB380", color: "#8B2500"
                                                            }}
                                                        >
                                                            <h5 className="card-title mb-0">
                                                                Sala de 4 años
                                                            </h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div style={{
                                                                marginBottom: "1rem",
                                                                display: "flex",
                                                                gap: "0.5rem",
                                                                flexWrap: "wrap"
                                                            }}>
                                <span
                                    className="badge"
                                    style={{
                                        backgroundColor: "#FF5500",
                                        borderRadius: "5px",
                                        color: "white",
                                    }}
                                >
                                  Todo sobre mi
                                </span>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#FF5500",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Mis hábitos y rutinas
                                                                </span>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#FF5500",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Mi familia
                                                                </span>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#FF5500",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Mi cuerpo y salud
                                                                </span>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#FF5500",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Mi alimentación
                                                                </span>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    backgroundColor: "#FFE5CC",
                                                                    padding: "1rem",
                                                                    borderRadius: "0.25rem"
                                                                }}
                                                            >
                                                                <div style={{color: "#8B2500"}}>
                                                                    <strong>Clave curricular:</strong> Desarrollo
                                                                    personal y social de los niños
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div
                                                        className="card h-100"
                                                        style={{
                                                            backgroundColor: "#F0F8F0",
                                                            borderColor: "#33742c",
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: "#7FB377",
                                                                color: "#1A3D18",
                                                            }}
                                                        >
                                                            <h5 className="card-title mb-0">
                                                                Sala de 5 años
                                                            </h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div style={{
                                                                marginBottom: "1rem",
                                                                display: "flex",
                                                                gap: "0.5rem",
                                                                flexWrap: "wrap"
                                                            }}>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#33742c",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Mi huella en el Planeta
                                                                </span>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#33742c",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Viaje a través de las palabras
                                                                </span>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#33742c",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Soy argentino
                                                                </span>
                                                                <span
                                                                    className="badge"
                                                                    style={{
                                                                        backgroundColor: "#33742c",
                                                                        borderRadius: "5px",
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                  Rumbo a primer grado
                                                                </span>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    backgroundColor: "#d4ead4",
                                                                    padding: "1rem",
                                                                    borderRadius: "0.25rem"
                                                                }}
                                                            >
                                                                <div style={{color: "#1A3D18"}}>
                                                                    <strong>Clave curricular:</strong>{" "}
                                                                    Alfabetización cultural para el desarrollo de
                                                                    una ciudadanía responsable
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="2a">
                                    <div className="list-style">
                                        <div className="col-lg-12 col-sm-12 col-xs-12">
                                            <div className="row">
                                                {[
                                                    {name: "Inglés", icon: "🌍"},
                                                    {name: "Matemáticas", icon: "🔢"},
                                                    {name: "Práctica del lenguaje", icon: "📚"},
                                                    {name: "Ciencias naturales y tecnología", icon: "🔬"},
                                                    {
                                                        name: "Ciencias sociales",
                                                        icon: "🏛️"
                                                    },
                                                    {
                                                        name: "Formación ética y ciudadana",
                                                        icon: "⚖️"
                                                    },
                                                ].map((subject, index) => (
                                                    <div key={index} className="col-md-6 col-lg-4"
                                                         style={{marginBottom: "2rem"}}>
                                                        <div
                                                            className="card h-100 text-center"
                                                            style={{
                                                                backgroundColor: "#F0F8F0",
                                                                borderColor: "#33742c",
                                                            }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="fs-1 mb-2">{subject.icon}</div>
                                                                <h5
                                                                    className="card-title"
                                                                    style={{
                                                                        color: "#33742c",
                                                                    }}
                                                                >
                                                                    {subject.name}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/*<ul>
                                                <li>Inglés.</li>
                                                <li>Matemáticas</li>
                                                <li>Práctica del lenguaje.</li>
                                                <li>Ciencias naturales y tecnología.</li>
                                                <li>
                                                    Ciencias sociales con formación ética y ciudadanía.
                                                </li>
                                            </ul>*/}
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="3a">
                                    <div className="list-style">
                                        <div className="col-lg-12 col-sm-12 col-xs-12">
                                            <div className="row">
                                                {[
                                                    {name: "Inglés", icon: "🌍"},
                                                    {name: "Biología", icon: "🧬"},
                                                    {name: "Geografía", icon: "🗺️"},
                                                    {name: "Matemáticas", icon: "🔢"},
                                                    {name: "Lengua y literatura", icon: "📖"},
                                                    {name: "Física (A partir de 9°)", icon: "⚛️"},
                                                    {name: "Química (A partir de 9°)", icon: "🧪"},
                                                    {name: "Historia", icon: "🏛️"},
                                                    {name: "Formación ética y ciudadana", icon: "⚖️"},
                                                ].map((subject, index) => (
                                                    <div key={index} className="col-md-6 col-lg-4"
                                                         style={{marginBottom: "2rem"}}>
                                                        <div
                                                            className="card h-100 text-center"
                                                            style={{
                                                                backgroundColor: "#F0F8F0",
                                                                borderColor: "#33742c",
                                                            }}
                                                        >
                                                            <div className="card-body">
                                                                <div className="fs-1 mb-2">{subject.icon}</div>
                                                                <h5
                                                                    className="card-title"
                                                                    style={{
                                                                        color: "#33742c",
                                                                    }}
                                                                >
                                                                    {subject.name}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/*<ul>
                                                <li>Inglés.</li>
                                                <li>Biología.</li>
                                                <li>Geografía.</li>
                                                <li>Matemáticas</li>
                                                <li>Lengua y literatura.</li>
                                                <li>Física. (A partir de 9°)</li>
                                                <li>Química. (A partir de 9°)</li>
                                                <li>Historia.</li>
                                                <li>Formación ética y ciudadana.</li>
                                            </ul>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "20px"}}>
                    <div className="section-title">
                        <h2>Plan de estudio</h2>
                    </div>
                    <p className="texto">
                        Nuestro programa anual está dividido en 32 semanas, desarrolladas
                        con diferentes recursos como videos, archivos PDF, elementos
                        multimedia interactivos, etc. Cada semana concluye con trabajos
                        prácticos o evaluaciones semanales para imprimir o en forma
                        digital, para el seguimiento y avance académico de los alumnos.
                        <br/> <br/>
                        <span style={{paddingLeft: "2em"}}/>Durante el ciclo lectivo se programarán algunos encuentros
                        vía
                        Google Meet o Zoom (en las areas de Matemáticas y Prácticas del
                        lenguaje, Física y Química en los grados mayores) Estos encuentros
                        NO serán obligatorios, serán opcionales.
                        <br/> <br/>
                        <span style={{paddingLeft: "2em"}}/>La finalidad de estos encuentros es que los alumnos
                        puedan interactuar entre ellos y con los profesores, diagnosticar
                        la asimilación de contenidos a través de situaciones de la vida
                        cotidiana desarrollando la expresión oral y el pensamiento
                        analítico.
                    </p>
                </div>
            </div>
            <br></br>
            <div className="col-md-8 col-md-offset-2 section-title">
                <h5>Formación Bíblica en todos los cursos (opcional)</h5>
            </div>
            <div className="col-md-12 section-title">
                <h4>
                    Horizonte no otorga certificados oficiales. Solo brindamos los
                    contenidos para ser certificados.
                </h4>
            </div>
        </div>
    );
};
